// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__1lkaf","title":"Images45_title__UnZLc","images":"Images45_images__3Nz85"};